const inr = new Intl.NumberFormat("en-IN", { maximumFractionDigits: 0 })

/** Rupees with Indian grouping: ₹12,00,000. Zero reads "nil"; unknown reads "not worked out". */
export function rupees(n: number | null | undefined): string {
  if (n === null || n === undefined) return "not worked out"
  if (n === 0) return "nil"
  return `₹${inr.format(Math.round(n))}`
}
